import {FormControl} from 'platform/components';

import {RefObject} from 'react';
import {useFormState} from 'react-hook-form';

import {GeneralSettingsFormValues} from '../types/GeneralSettingsFormValues';

interface RegisterFormSubmitProps {
  control: FormControl<GeneralSettingsFormValues>;
  formSubmitRef: RefObject<(() => Promise<boolean>) | null>;
  isDirtyRef: RefObject<boolean>;
}

// Exposes the current general settings submit handler to sibling platform actions.
export function RegisterFormSubmit(props: RegisterFormSubmitProps) {
  const {isDirty} = useFormState({control: props.control});
  props.isDirtyRef.current = isDirty;
  props.formSubmitRef.current = () => props.control.submitForm();
  return null;
}
